<template>
  <div>
    <v-progress-circular v-if="status === 'updating'" indeterminate/>
    <vf-tooltip :text="tooltip" v-if="status === 'unhealthy'" :max-width="400">
      <v-icon color="warning">mdi-alert</v-icon>
    </vf-tooltip>
    <v-icon v-else color="success">mdi-check-bold</v-icon>
  </div>
</template>
<script>
import VfTooltip from '@/components/shared/VfTooltip'
export default {
  name: 'VehicleViewIssueIcon',
  components: {
    VfTooltip
  },
  props: {
    status: {
      String
    },
    tooltip: {
      String
    }
  }
}
</script>
